import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';

import RequestCalloutTypes from '../types/RequestCalloutTypes';
import TypeColumnIcon from './TypeColumnIcon';
import CalloutButtonForDriver from './CalloutButtonForDriver';
import RequestedAgoLabel from './RequestedAgoLabel';
import CalloutStatusLabelForDriver from './CalloutStatusLabelForDriver';
import { ICalloutActions } from './types/calloutResponseTypes';
import IAuthState from '../../../interfaces/IAuthState';
import CalloutStatuses from '../types/CalloutStatuses';
import clsx from 'clsx';


interface CalloutTableForDriverProps {
    calloutList: IRequestCalloutDTO[],
    calloutActions: ICalloutActions,
    authStore: IAuthState
};

const useStyles = makeStyles(() => ({
    container: {},
    table: {
        width: "100%",

        tableLayout: "fixed",
        backgroundColor: "#00152E"
    },
    muiTableBody: {
        backgroundColor: "#fff",
    },
    tableHead: {
        backgroundColor: "#00152E",
        paddingLeft: 30,
        "& > *": {
            fontSize: 18,
            fontWeight: 400,
            opacity: 0.30,
        }
    },
    tableBody: {
        backgroundColor: "#002047",
        cursor: "pointer",
        "& > *": {
            fontSize: 18,
            fontWeight: 500
        },
        height: 33
    },
    tableCell: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        height: 33,

        "@media (max-width: 1024px)": {
            whiteSpace: "normal",
          },
    },
    tableHeadFirst: {
        paddingLeft: '40px !important',
    },
    myVehicleCell:{
        backgroundColor: 'rgba(63, 160, 82, 0.23)'
    }
}));

const checkMyVehicle = (authStore: IAuthState, 
    row: IRequestCalloutDTO): boolean => (row.assignedVehicle 
        && authStore.vehicleNumber === row.assignedVehicle 
        && (row.status??0) > CalloutStatuses.dispatchedToTeam)?true:false;

const getActiveCalloutId = (authStore: IAuthState, 
    calloutList: IRequestCalloutDTO[]): string|null => {
    if(!authStore.vehicleNumber) return null;
    const activeCallout = calloutList.find(row => 
        checkMyVehicle(authStore, row) &&
        ((row.status??0)> CalloutStatuses.teamAcknowledged) &&
        ((row.status??0) < CalloutStatuses.teamDeparted) 
    );
    if(activeCallout){
        return activeCallout.requestCalloutId;
    }else{
        return null
    }
};

const CalloutTableForDriver: React.FC<CalloutTableForDriverProps> = ({ 
    calloutList, 
    calloutActions,
    authStore}) => {
    const classes = useStyles();
    const myVehicleCellStyle = clsx(classes.tableCell, classes.myVehicleCell);
    const EmptyRow = (<TableRow className={classes.tableCell}>
        <TableCell align="center" colSpan={9}>No Records Found</TableCell>
    </TableRow>);
    const activeRequestCalloutId = getActiveCalloutId(authStore,calloutList);
    return (
        <div className={classes.container}>
            <Table size="small" aria-label="purchases" style={{ tableLayout: "fixed" }}>
                <TableHead>
                    <TableRow className={classes.tableHead}>
                        <TableCell className={classes.tableHeadFirst} width="6%">Type</TableCell>
                        <TableCell width="14%">Requested</TableCell>
                        <TableCell width="20%">Location</TableCell>
                        <TableCell width="16%">Section</TableCell>
                        <TableCell width="26%"></TableCell>
                        <TableCell width="18%"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {calloutList.length === 0 ? EmptyRow :
                        calloutList.map((row, index) => {
                            const isItIncident = row.type === RequestCalloutTypes.incidentCallout;
                            const isMyVehicle = checkMyVehicle(authStore, row);
                            const cellClass = isMyVehicle?myVehicleCellStyle:classes.tableCell;
                            return (
                                <React.Fragment key={row.requestCalloutId}>
                                    <TableRow
                                        onClick={() => { }}
                                        hover
                                        className={classes.tableBody}
                                    >
                                        <TableCell className={cellClass} style={{ paddingLeft: '40px' }}>
                                            <TypeColumnIcon isItIncident={isItIncident} />
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                                <RequestedAgoLabel 
                                                    row={row}
                                                    isMyVehicle={isMyVehicle} 
                                                />
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                            {row.locationName ?? '-'}
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                            {row.wardName ?? '-'}
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                            <CalloutStatusLabelForDriver 
                                            row={row} 
                                            undoRequestCallout ={calloutActions.undoRequestCallout}
                                            isMyVehicle={isMyVehicle}
                                            activeRequestCalloutId={activeRequestCalloutId} />
                                        </TableCell>
                                        <TableCell className={cellClass} style={{padding:0}}>
                                            <CalloutButtonForDriver 
                                                row={row}
                                                calloutActions={calloutActions}
                                                isMyVehicle={isMyVehicle} 
                                                activeRequestCalloutId={activeRequestCalloutId}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )
                        })}
                </TableBody>
            </Table>
        </div>
    );
}

export default CalloutTableForDriver;